<template>
  <fragment>
    <transaction-table-item
      class="transactions-bills-to-card-table-item"
      v-if="type === 'transaction'"
      ref="transactionItem"
      :transaction="transaction"
      :details-blocks="transaction.TRANSACTION_DETAIL_BLOCKS"
    >
      <template #shortInfo>
        <div class="transaction-table-item__col transaction-table-item__date">
          <div class="transaction-table-item__date-main">
            {{ transaction.transactionDate }}
          </div>
          <div class="transaction-table-item__date-time">
            {{ transaction.transactionTime }}
          </div>
        </div>
        <div
          class="transaction-table-item__col transaction-table-item__recipient"
        >
          {{ transaction.userFullName }}
        </div>
        <div class="transaction-table-item__col transaction-table-item__phone">
          {{ transaction.userPhone }}
        </div>
        <div class="transaction-table-item__col transaction-table-item__email">
          {{ transaction.userEmail || '-' }}
        </div>

        <div
          class="transaction-table-item__col transaction-table-item__account-number"
        >
          {{ transaction.orderNumber }}
        </div>
        <div class="transaction-table-item__col transaction-table-item__">
          {{ transaction.billInfo.purpose }}
        </div>

        <div class="transaction-table-item__col transaction-table-item__amount">
          {{ transaction.transactionAmount }}
          {{ transaction.transactionCurrency }}
        </div>
        <div class="transaction-table-item__col transaction-table-item__status">
          <transaction-status
            :status-id="transaction.operationStatus"
          ></transaction-status>
        </div>
        <transactions-table-actions-button
          class="transaction-table-item__col transaction-table-item__actions"
          :actions="itemActions"
          ref="actionsMenu"
          @actionFired="handleActionFired"
        >
        </transactions-table-actions-button>
      </template>
    </transaction-table-item>
    <div class="bills-to-card-table-item" v-else>
      <div class="transaction-table-item">
        <div class="transaction-table-item__short-info">
          <div class="transaction-table-item__col transaction-table-item__date">
            <div class="transaction-table-item__date-main">
              {{ itemDateTime.date }}
            </div>
            <div class="transaction-table-item__date-time">
              {{ itemDateTime.time }}
            </div>
          </div>
          <div
            class="transaction-table-item__col transaction-table-item__recipient"
          >
            <span>{{ billsRegistryItem.recipient_name }}</span>
          </div>
          <div
            class="transaction-table-item__col transaction-table-item__phone"
          >
            <span>{{ billsRegistryItem.recipient_phone }}</span>
          </div>
          <div
            class="transaction-table-item__col transaction-table-item__email"
          >
            <span>{{ billsRegistryItem.recipient_email }}</span>
          </div>
          <div
            class="transaction-table-item__col transaction-table-item__account-number"
          >
            <span>{{ billsRegistryItem.order_number }}</span>
          </div>
          <div
            class="transaction-table-item__col transaction-table-item__appointment"
          >
            <span>{{ billsRegistryItem.purpose }}</span>
          </div>
          <div class="transaction-table-item__col transaction-table-item__sum">
            <span>{{ billsRegistryItem.sum }}</span>
          </div>

          <div
            class="transaction-table-item__col transaction-table-item__status"
          >
            <transaction-status :status-id="status"></transaction-status>
          </div>

          <transactions-table-actions-button
            :actions="itemActions"
            ref="actionsMenu"
            @actionFired="handleActionFired"
          >
          </transactions-table-actions-button>
        </div>
      </div>
    </div>
    <share-bill-link-popup
      ref="shareBillLinkPopup"
      :bill="bill"
    ></share-bill-link-popup>
    <transaction-receipt-popup
      :transaction="transaction"
      :pdf-blob="transactionReceiptBlob"
      ref="transactionReceiptPopup"
    ></transaction-receipt-popup>
  </fragment>
</template>

<script>
import {
  $on,
  $off,
  $once,
  $emit,
} from '../../../../../../../utils/gogocodeTransfer'
import TransactionStatus from '@vue-app/components/transaction/TransactionStatus.vue'
import { CompaniesApi } from '@js-app/office/api/companies-api'
import { RouteHelper } from '@js-app/services/helpers/routes/routes-helper'
import { mapState } from 'vuex'
import Loader from '@vue-app/components/base/Loader.vue'
import TransactionsTableActionsButton from '@vue-app/components/company/transactions/table/TransactionsTableActionsButton.vue'
import TextInput from '@vue-app/components/base/input/TextInput.vue'
import { ERROR } from '@js-app/const/operation-statuses-ids'
import moment from 'moment/moment'
import { addTrailingZeros } from '@js-app/services/helpers/math'
import TransactionTableItem from '@vue-app/components/company/transactions/table/TransactionsTableItem.vue'
import { Transaction } from '@js-app/entities/transaction/Transaction'
import { Bill } from '@js-app/entities/Bill'
import TransactionReceiptPopup from '@vue-app/components/company/transactions/popup/TransactionReceiptPopup.vue'
import ShareBillLinkPopup from '@vue-app/components/company/bills/popup/ShareBillLinkPopup.vue'
import { SupportService } from '@js-app/services/support/support-service'

export default {
  name: 'BillsRegistryMainTableItem',
  components: {
    ShareBillLinkPopup,
    TransactionReceiptPopup,
    TransactionTableItem,
    TextInput,
    TransactionsTableActionsButton,
    Loader,
    TransactionStatus,
  },
  props: {
    billsRegistryItem: {
      type: Object,
    },
  },
  data() {
    return {
      isPayoutsRegistryItemUpdated: false,
      transactionReceiptBlob: null,
      payoutsRegistryItemUpdated: {
        ...this.billsRegistryItem,
        sum: (parseInt(this.billsRegistryItem.sum) / 100).toFixed(2),
      },
    }
  },
  computed: {
    ...mapState(['selectedCompany']),
    type() {
      return this.billsRegistryItem.operation_id === 0 ||
        this.billsRegistryItem.operation_id === null
        ? 'default'
        : 'transaction'
    },
    transaction() {
      return new Transaction(this.billsRegistryItem.operation_data)
    },
    bill() {
      return new Bill(this.billsRegistryItem.operation_data)
    },
    itemActions() {
      let _actions = []

      if (this.transaction.canGetReceipt) {
        _actions.push({
          id: 'get-receipt',
          title: this.$t('transaction-actions.get-receipt'),
          handler: this.loadReceipt,
        })
      }

      if (this.transaction.canMakeRefund || this.transaction.canCancelPreAuth) {
        _actions.push({
          id: 'make-refund',
          title: this.$t('transaction-actions.make-refund'),
          handler: this.toBillRefund,
          accessControl: {
            action: 'read',
            data: 'bills-refund',
          },
        })
      }

      if (
        this.transaction.operationStatus !== ERROR &&
        this.billsRegistryItem.status !== 'error'
      ) {
        _actions.push({
          id: 'bill-details',
          title: this.$t('transaction-actions.bill-details'),
          handler: this.toBillDetails,
        })

        _actions.push({
          id: 'bill-details',
          title: this.$t('transaction-actions.bill-share'),
          handler: this.shareBill,
        })
      }

      _actions.push({
        id: 'support-tg-chat',
        title: this.$t('transaction-actions.support-tg-chat'),
        handler: this.goToSupportPage,
      })

      return _actions
    },
    itemDateTime() {
      return {
        date: moment(this.billsRegistryItem.date_update).format('DD.MM.YYYY'),
        time: moment(this.billsRegistryItem.date_update).format('HH:mm:ss'),
      }
    },

    itemSum() {
      return `${addTrailingZeros(
        (parseInt(this.billsRegistryItem.sum) / 100).toLocaleString()
      )} ₴`
    },
    status() {
      if (this.billsRegistryItem.status === 'completed') {
        return 0
      }
      if (this.billsRegistryItem.status === 'error') {
        return ERROR
      }

      return this.billsRegistryItem.status
    },
    fullName() {
      let _fullNameParts = this.billsRegistryItem.recipient_name.split(' ')

      let _lastName = _fullNameParts[0] || ''

      if (_lastName.length > 2) {
        let _lastNameFirstChar = _lastName[0],
          _lastNameLastChar = _lastName[_lastName.length - 1]

        _lastName =
          _lastNameFirstChar +
          ''.padEnd(_lastName.length, '*') +
          _lastNameLastChar
      } else if (_lastName.length > 0 && _lastName.length <= 2) {
        let _lastNameFirstChar = _lastName[0]

        _lastName = _lastNameFirstChar + ''.padEnd(2, '*')
      }

      _fullNameParts[0] = _lastName

      return _fullNameParts.join(' ')
    },
  },
  methods: {
    goToSupportPage() {
      return SupportService.goToSupportPage(this.$router, this.selectedCompany)
    },
    async handleActionFired(action) {
      try {
        await action.handler()
      } catch (e) {
        console.error(e)
      }

      try {
        this.$refs.transactionItem.actionFinished(action.id)
      } catch (e) {}
    },
    handleDeleteItem() {
      $emit(this, 'deleted', this.billsRegistryItem)
    },
    handleUpdatePayoutRegistryItem() {
      if (this.isPayoutsRegistryItemUpdated) {
        this.isPayoutsRegistryItemUpdated = false
        $emit(this, 'updated', this.payoutsRegistryItemUpdated)
      }
    },
    repeatPayout() {
      $emit(this, 'repeatPayout', this.billsRegistryItem)
      this.$refs.actionsMenu.actionFinished('repeat-payout')
    },
    async toBillDetails() {
      await this.$router.push(
        RouteHelper.getRoute('bill-view', {
          companyId: this.selectedCompany,
          billId: this.transaction.operationId,
        })
      )
    },
    async toBillRefund() {
      await this.$router.push(
        RouteHelper.getRoute('bill-refund', {
          companyId: this.selectedCompany,
          billId: this.transaction.operationId,
        })
      )
    },
    async loadReceipt() {
      let receiptResponse = await CompaniesApi.getBillReceipt(
        this.selectedCompany,
        this.transaction.operationId
      )
      this.transactionReceiptBlob = URL.createObjectURL(receiptResponse.data)
      return this.$refs.transactionReceiptPopup.open()
    },
    async shareBill() {
      const _bill = new Bill(await this.$refs.transactionItem.loadFullInfo())
      this.$refs.shareBillLinkPopup.open(_bill)
    },
  },
  emits: ['deleted', 'updated', 'repeatPayout'],
}
</script>

<style lang="scss" scoped>
.transactions-bills-to-card-table-item {
  .bills-transaction-table-item__short-info {
    display: flex;
    justify-content: space-between;

    .transaction-table-item__col {
      .transaction-table-item__account-number {
        justify-content: center;
      }
    }
  }
}
.bills-to-card-table-item {
  .transaction-table-item__short-info {
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 20px;
    .transaction-table-item__col {
      width: max-content;
      flex: 1;
    }
  }

  .transaction-table-item {
    &__date {
      padding: 0;
    }

    &__phone {
      word-break: break-all;
    }

    &__email {
      word-break: break-all;
    }

    &__name {
      word-break: break-all;
      font-weight: 500;
      font-size: 14px;
      line-height: 18px;
      color: #1a1f29;
      opacity: 0.7;
    }

    &__account-number {
      justify-content: center;
    }

    &__amount,
    &__sum {
      font-weight: 600;
      font-size: 14px;
      line-height: 18px;
      color: #1a1f29;
      opacity: 0.7;
      justify-content: center;
    }

    &__commission {
      justify-content: center;
    }

    &__currency {
      justify-content: flex-end;
    }

    &__delete {
      justify-content: center;
    }

    &__status {
      align-self: center;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-left: 20px;
      padding-right: 20px;

      &-item {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 105px;
        max-width: 100%;
        height: 28px;
        border-radius: 6px;
        font-weight: 500;
        font-size: 12px;
        line-height: 28px;

        &--paid {
          background: rgba(39, 204, 36, 0.2);
          color: #44d941;
        }
      }
    }

    &__actions {
      justify-content: flex-end;
    }
  }
}
</style>
